import { useSortable } from "@dnd-kit/sortable";
import { useDndContext } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

import { Box, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

const SortableBlock = ({ id, title, enableSorting, children }) => {
  const { active } = useDndContext();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: !enableSorting });

  const showCollapsedCard = enableSorting && Boolean(active);

  return (
    <Box
      ref={setNodeRef}
      style={
        enableSorting
          ? {
              transform: CSS.Transform.toString(transform),
              transition,
              opacity: isDragging ? 0 : 1,
            }
          : undefined
      }
    >
      {showCollapsedCard && (
        <Box
          sx={{
            backgroundColor: "#fff",
            border: "2px solid #d3d3d3",
            borderRadius: "15px",
            px: 2,
            pb: 1,
            boxShadow:
              "0px 4px 6px rgba(0, 0, 0, 0.4), 0px 1px 3px rgba(0, 0, 0, 0.08)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <DragIndicatorIcon
              {...attributes}
              {...listeners}
              sx={{
                position: "absolute",
                left: 0,
                fontSize: "1.4rem",
                fill: "#ababab",
                cursor: "grab",
              }}
            />
            <Typography
              variant="h5"
              align="center"
              mb={2}
              mt={1}
              color="primary"
            >
              {title}
            </Typography>
          </Box>
        </Box>
      )}

      <Box sx={{ display: showCollapsedCard ? "none" : "block" }}>
        {enableSorting && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <DragIndicatorIcon
              {...attributes}
              {...listeners}
              sx={{
                fontSize: "1.4rem",
                fill: "#ababab",
                cursor: "grab",
                transform: "rotate(90deg)",
              }}
            />
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default SortableBlock;
